import { render, staticRenderFns } from "./ChatDetailPanel.vue?vue&type=template&id=37fb1483&scoped=true&"
import script from "./ChatDetailPanel.vue?vue&type=script&lang=ts&"
export * from "./ChatDetailPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fb1483",
  null
  
)

export default component.exports